import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Field',

  mixins: [ proxy() ],

  props: {
    clearable: Boolean,
    required: Boolean,
    details: Boolean
  },

  render
}
